module.exports = __webpack_public_path__ + "static/img/character-pisces.a8ba9eb5.png";